import { toast } from "sonner";

import { useVidyoStore } from "@/features/vidyo-call/utils/vidyo-store";
import { isSessionConflict } from "@/types/error";

import { useExtendSession } from "../api/extend-session";

import { QuickExtendButton } from "./quick-extend-button";

export function QuickExtend() {
  const setConflictingSessions = useVidyoStore(
    (state) => state.moderationDrawer.setConflictingSessions,
  );
  const sessionId = useVidyoStore((state) => state.sessionId);
  const { mutateAsync: extendSession, isPending: isExtendingSession } =
    useExtendSession({
      onMutate: () => {
        setConflictingSessions(undefined);
      },
      onSuccess: () => {
        toast.success("Session extended");
        setConflictingSessions(undefined);
      },
      onError: (error) => {
        if (isSessionConflict(error)) {
          setConflictingSessions(error.conflictingSessions);
        } else {
          toast.error(error.message);
        }
      },
    });

  const minutes = [5, 10, 15, 20, 30];

  const handleExtendSession = async (minutes: number) => {
    await extendSession({
      sessionId,
      payload: { extensionInMinutes: minutes },
    });
  };

  return (
    <div className="mb-6 flex flex-wrap gap-1.5">
      {minutes.map((minute) => (
        <QuickExtendButton
          key={minute}
          minutes={minute}
          disabled={isExtendingSession}
          onClick={() => handleExtendSession(minute)}
        />
      ))}
    </div>
  );
}
